import { TripType } from '@eti/schema-types';
import type { TripDataType } from '../../../../../../common/custom-hooks/save-trips/models';
import type { TripSegmentType } from '../../../../models';

const getTripSegmentsFromBound = (bound: TripDataType['bounds'][number]): TripSegmentType[] =>
  bound.segments.filter(
    (segment): segment is TripSegmentType => segment.__typename === 'TripSegment',
  );

export const getOriginAndDestination = (
  bounds: TripDataType['bounds'],
  tripType: TripDataType['type'],
) => {
  const tripSegmentsFromFirstBound = getTripSegmentsFromBound(bounds[0]);
  const { origin } = tripSegmentsFromFirstBound[0];

  if (tripType === TripType.OneWay || tripType === TripType.Return) {
    const lastSegment = tripSegmentsFromFirstBound[tripSegmentsFromFirstBound.length - 1];
    return {
      origin,
      destination: lastSegment.destination,
    };
  }

  const tripSegmentsFromLastBound = getTripSegmentsFromBound(bounds[bounds.length - 1]);
  const lastSegment = tripSegmentsFromLastBound[tripSegmentsFromLastBound.length - 1];
  return {
    origin,
    destination: lastSegment.destination,
  };
};
